import React, { useEffect, useState } from 'react'
import { LoadCoins } from './Components/LoadCoins/LoadCoins'
import { UsersPanel } from './Components/UsersPanel/UsersPanel'
import { Col, Row } from 'react-bootstrap'
import { getCbuInformation } from '../../Api/CBU/Cbu'
import { GetCbuResponse } from '../../Api/CBU/models'
import { CopyPastes } from './Components/CopyPastes'
import { CbuInfo } from './Components/CbuInfo'
import { fetchAdminPublicInfo } from '../../Api/Admin/Admin'
import { AdminPublicInfo } from '../../Api/Admin/models'
import { useSocket } from '../../../../hooks/useSocket'
import { NoteTaker } from './Components/NoteTaker/NoteTaker'
import { UserResponse } from '../../Api/User/models'

export const Home = ({ embed = false, userInfo }: { embed?: boolean, userInfo?: null | UserResponse }) => {
  const { socket } = useSocket();

  const [cbuData, setCbuData] = useState<GetCbuResponse | null>(null)
  const [adminInfo, setAdminInfo] = useState<AdminPublicInfo | null>(null);

  const getCbuInfo = async () => {
    const data = await getCbuInformation()
    if (data) {
      setCbuData(data)
    }
  }

  const getAdminInfo = async () => {
    const info = await fetchAdminPublicInfo()
    if (info) {
      setAdminInfo(info)
    }
  }

  useEffect(() => {
    getCbuInfo();
    getAdminInfo();
  }, [])

  useEffect(() => {
    if (socket) {
      socket.on('cbu-updated', (data: any) => {
        if (adminInfo?.id === data?.OwnerId) {
          getCbuInfo();
        }
      });
    }
  }, [socket, adminInfo]);

  return (
    <div className="mt-4 pb-5">
      <Row>
        <Col md={embed ? 12 : 6} className={`d-flex justify-content-start ${embed ? 'mt-0' : 'mt-5'}`}>
          <LoadCoins adminInfo={adminInfo} fetchedData={cbuData} />
        </Col>
        <Col md={embed ? 12 : 6} className={`d-flex justify-content-start ${embed ? 'mt-2' : 'mt-5'}`}>
          <UsersPanel adminInfo={adminInfo} fetchedData={cbuData} />
        </Col>
        <Col md={embed ? 12 : 6} className='d-flex justify-content-start mt-2 panel-default'>
          <CopyPastes fetchedData={cbuData} adminInfo={adminInfo} />
        </Col>
        <Col md={embed ? 12 : 6} className='d-flex flex-column mt-2 panel-default'>
          <CbuInfo cbuData={cbuData} getCbuInfo={getCbuInfo} />
          <div className="mt-3">
            <NoteTaker userInfo={userInfo} />
          </div>
        </Col>
      </Row>
    </div>
  )
}
